var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.5 47.5",
    id: "Fork",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 38h38V0H0v38Z",
    fill: "#a86604",
    className: "color000000 svgShape"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffbf66",
    clipPath: "url(#a)",
    transform: "matrix(1.25 0 0 -1.25 0 47.5)",
    className: "color99aab5 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 35.5a1.5 1.5 0 1 1-3 0V26a1 1 0 0 0-2 0v9.5a1.5 1.5 0 1 1-3 0V26a1 1 0 0 0-2 0v9.5a1.5 1.5 0 1 1-3 0v-9c0-.127.021-.249.051-.367A4.395 4.395 0 0 1 7 25.5c0-2.316 1.75-5.957 4-6.442V3.5a2.5 2.5 0 1 1 5 0v15.558c2.25.485 4 4.126 4 6.442 0 .216-.021.426-.051.633.03.118.051.24.051.367v9zM28.5 37c-.104 0-.204-.019-.306-.031-.064.01-.127.031-.194.031-2.209 0-5-5.477-5-11 0-4.658 1.275-8.561 3-9.672V3.5a2.5 2.5 0 1 1 5 0v31a2.5 2.5 0 0 1-2.5 2.5",
    fill: "#a86604",
    className: "color000000 svgShape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFork);
export default __webpack_public_path__ + "static/media/fork.1846ba75982e15222a8f73366f3dc9f0.svg";
export { ForwardRef as ReactComponent };